// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__l6Sp3","newExpiryDate":"styles_newExpiryDate__UUWjd","footer":"styles_footer__s67fW"};